var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Contact Us","intro":"For questions or feedback about the content on this site, you can reach us at the address below.","sections":_vm.sections,"email":"contact@gbwhatsdroid.com","page-name":"contact"}})
}
var staticRenderFns = []

export { render, staticRenderFns }